import styled, { css } from "styled-components";

import Box from "@storeblocks/box";
import { stbColors } from "Components/Themes/Storebrand/storebrandColors";
import { isDefined } from "Utils/functions";
import { Alert as CustomAlert } from "./Alert";

export const CardHeading = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 12px;
`;

export const CardContent = styled(Box)`
  & > p {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 6px;

    & > a {
      color: ${stbColors.stbRed};
    }
  }
`;

export const transparentStyle = css`
  background-color: transparent;
  border-color: transparent;
  outline-color: transparent;
`;

export const Alert = styled(CustomAlert)`
  min-width: 180px;
  ${({ marginBottom }) => {
    if (isDefined(marginBottom)) {
      return `margin-bottom: ${marginBottom};`;
    }
    return ``;
  }}
  ${({ marginTop }) => {
    if (isDefined(marginTop)) {
      return `margin-top: ${marginTop};`;
    }
    return ``;
  }}
`;

export const CoopIconWrapper = styled(Box)`
  height: 100%;
  width: 100%;

  & > div {
    align-self: center;
  }

  svg {
    height: 100%;
    width: 96px;
  }
`;

export const DesktopBox = styled(Box)`
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const SimpleInfoAlert = styled.div`
  background-color: ${stbColors.alert.info.background};
  border-radius: 4px;
  color: var(--p-color-text-on-info);
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
  padding: 16px;
`;

export const SimpleAlertTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 8px;
`;

export const SimpleAlertDesc = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;
